<script setup>
import { ref } from "vue";
import { useI18n } from 'vue-i18n';
import YautyTable from '@/components/common/yautyTable/YautyTable.vue';

const { t } = useI18n();
const i18n = useI18n();

const offset = ref(0);
const carsDisplayed = ref(6);


const headers = [
    {
        text: t('vehicle.license_plate') + '/' + t('vehicle.vin'),
        value: 'plate',
        src: 'plate',
        field: 'plate',
        styles: { 'letterSpacing': '0px', 'font-size': '1rem', 'font-weight': '100', 'max-width': '300px' },
        width: '',
        visible: true,
        fixedWidth: true,
    },
    {
        text: t('vehicle.brand') + '/' + t('vehicle.model'),
        value: 'brand',
        src: 'brand',
        field: 'model',
        width: '',
        styles: { 'letterSpacing': '0px', 'width': '10rem' },
        visible: true,
        fixedWidth: true
    },
    {
        text: t("vehicle.itv_date"),
        value: "inspection_date",
        src: 'inspection_date',
        field: 'model',
        width: '80px',
        visible: true,
        fixedWidth: true,
    }
];

const listPage = ref(1);
const props = defineProps({
    vehicles: Array
});

const vehiclesFormat = ref([]);
props.vehicles.map((item) => {
    let v = {};
    let plate = item.plate
    if(item.vin) {
        if(plate && plate != '') {
            plate += ' / ' + item.vin;
        } else {
            plate = item.vin
        }
    }
    let brand = item.brand
    if(item.model) {
        if(brand && brand != '') {
            brand += ' / ' + item.model;
        } else {
            brand = item.model
        }
    }
    v = {
        plate: plate,
        brand: brand,
        inspection_date: item.inspection_date ? item.inspection_date.split(' ')[0] : 'N/D'
    }
    vehiclesFormat.value.push(v);
});



function changePage(index) {
    listPage.value = index+1;


}
</script>

<template>
    <div class="invitation__client_vehicle pt-3">
        
        <div class="invitation_data_vehicles_wrapper">
            <YautyTable
                :headers="headers"
                :items="vehiclesFormat.slice((listPage -1) * carsDisplayed, (listPage -1) * carsDisplayed + carsDisplayed)"
                :total="vehicles.length"
                :render="'server'"
                :offset="offset"
                :expandable="false"
                :filtrable="false"
                :page="listPage"
                :pagination="true"
                :limit="carsDisplayed"
                table="invitationVehiclesList"
                @callLoadPage="changePage"
                />
        </div>
    </div>
</template>

<style lang="scss" scoped>


</style>